import { DEFAULT_LOCALE } from '../data'

export default function getLocalizedPath(
  to = '/',
  currentLocale = DEFAULT_LOCALE,
  isDefaultLocale = false
): string {
  return isDefaultLocale ? to : `/${currentLocale}${to}`
}
